import React,{useEffect} from 'react'
import {  Map as LeafletMap ,TileLayer ,Marker} from "react-leaflet"
import './Map.css'
import { showDataOnMap } from './util'
 function Map({countries,casesType,center,zoom}) {



    return (
        <div className="map">
           <LeafletMap
               center={center} zoom={zoom}
           >
               <TileLayer 
               url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
               attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>contributors'
               >

               </TileLayer>


         {showDataOnMap(countries,casesType)}

           </LeafletMap>
        </div>
    )
}

export default Map
